export function getRoleDisplay(role: string): string {
    if (role === 'PARTNER') {
        return 'COMPANY';
    }

    return role;
}
